import { render, staticRenderFns } from "./IMEIStorageTime.vue?vue&type=template&id=0740de38"
import script from "./IMEIStorageTime.vue?vue&type=script&lang=js"
export * from "./IMEIStorageTime.vue?vue&type=script&lang=js"
import style0 from "./IMEIStorageTime.vue?vue&type=style&index=0&id=0740de38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports